import React, { FC } from 'react';
import { Text, Box, Separator, SeparatorType } from '@bechtel/gds';
import { t } from '@lingui/macro';
import { CaddyStatCardProps, RodRoomStatsProps } from './types';
import { RodRoomCaddyStatusFlag, RodRoomCaddyStatusStats } from '@bechtel/types';
import { find, includes } from 'lodash';

export const RodRoomStats: FC<RodRoomStatsProps> = ({ rodRoomCaddyStat }) => {
  const getCaddyStats = (status: RodRoomCaddyStatusFlag) => {
    const rodRoomStat: RodRoomCaddyStatusStats | undefined = find(
      rodRoomCaddyStat?.caddySummary,
      (item: RodRoomCaddyStatusStats) => includes(status, item?.status)
    );
    return rodRoomStat?.stats ? rodRoomStat.stats : 0;
  };

  return (
    <Box py={{ sm: '500' }}>
      <CaddyStatCard
        value={rodRoomCaddyStat?.numCaddies ? rodRoomCaddyStat.numCaddies : 0}
        valueColor="grey.1000"
        label={t`Total Caddies`}
      />
      <Separator data-testid="total-caddy-separator" color="grey.300" borderWidth="1px" type={SeparatorType.VERTICAL} />
      <CaddyStatCard value={getCaddyStats(RodRoomCaddyStatusFlag.ISSUED)} valueColor="red.500" label={t`Issued`} />
      <Separator
        data-testid="issued-caddy-separator"
        color="grey.300"
        borderWidth="1px"
        type={SeparatorType.VERTICAL}
      />
      <CaddyStatCard
        value={getCaddyStats(RodRoomCaddyStatusFlag.IN_HOUSE)}
        valueColor="grey.1000"
        label={t`In-House`}
      />
      <Separator
        data-testid="returned-caddy-separator"
        color="grey.300"
        borderWidth="1px"
        type={SeparatorType.VERTICAL}
      />
      <CaddyStatCard
        value={getCaddyStats(RodRoomCaddyStatusFlag.RETURNED_TO_OTHER_ROD_ROOM)}
        valueColor="grey.1000"
        label={t`Returned to other Rod Room`}
      />
    </Box>
  );
};

const CaddyStatCard: FC<CaddyStatCardProps> = ({ value, valueColor, label }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} px={{ sm: '700' }}>
      <Box mb={{ sm: '200' }}>
        <Text size="600" color={valueColor} weight="600">
          {value}
        </Text>
      </Box>
      <Text size="200" color="grey.1000">
        {label}
      </Text>
    </Box>
  );
};
